
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, Info } from "lucide-react";

export const MarketDataAnalysisHeader = () => {
  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Header */}
      <div className="px-1">
        <div className="flex items-center gap-2 mb-2">
          <BarChart3 className="h-5 w-5 sm:h-6 sm:w-6 text-green-500" />
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">Enhanced Market Data Analysis</h1>
        </div>
        <p className="text-sm sm:text-base text-muted-foreground">
          Comprehensive market analysis combining TradingView sentiment data with multi-timeframe technical signals
        </p>
      </div>

      {/* Info Card */}
      <Card className="bg-green-50 border-green-200">
        <CardContent className="pt-4 sm:pt-6 p-4 sm:p-6">
          <div className="flex items-start gap-3">
            <Info className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-medium text-green-900 text-sm sm:text-base">Enhanced Analysis Features</h3>
              <ul className="text-xs sm:text-sm text-green-700 mt-1 list-disc list-inside space-y-1">
                <li>Multi-timeframe trend confluence analysis (M1, M15, H1, H4, D1)</li>
                <li>Dynamic support/resistance level identification with reliability scores</li>
                <li>Market condition assessment (Stable/Normal/Volatile)</li>
                <li>Combined sentiment + technical confidence scoring</li>
                <li>Automated trading recommendations and market alerts</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
